import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { alpha, useTheme } from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import { capitalizeAllWords, getUserDescription, isValidUUID } from "../../utils/helpers";
import OmniAvatar from "../ui/omniAvatar";
import OmniEditButton from "../ui/omniEditButton";

const OmniUserListItem = props => {
  const { userODM, onClickHandler = null, onNavigateHandler = null } = props;
  const theme = useTheme();

  const getUserInitials = userODM => {
    let theReturn = userODM.omniData.givenName.charAt(0) + userODM.omniData.familyName.charAt(0);
    return theReturn.toUpperCase();
  };

  const getUserName = userODM => {
    if (userODM == null) {
      return "unknown";
    }
    let name = userODM.omniData.displayName
      ? userODM.omniData.displayName
      : `${userODM.omniData.givenName} ${userODM.omniData.familyName}`;
    return capitalizeAllWords(name);
  };

  return (
    <ListItem
      disableGutters={true}
      sx={{
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.spacing(1),
        borderRadius: theme.spacing(1),
        backgroundColor: alpha(theme.palette.info.main, 0.75),
        color: theme.palette.info.contrastText,
        cursor: "pointer",
        boxShadow: theme.shadows[3],
        userSelect: "none",
        webkitUserSelect: "none",
      }}
      onClick={e => {
        e.stopPropagation();
        if (onClickHandler) {
          onClickHandler(userODM);
        }
      }}
    >
      {isValidUUID(userODM._id) && (
        <Tooltip title={"No Notes"} placement="right">
          <>
            <OmniAvatar
              sx={{
                width: 36,
                height: 36,
                fontSize: "1.2rem",
                color: theme.palette.info.main,
                border: `2px solid ${theme.palette.info.contrastText}`,
              }}
            >
              {getUserInitials(userODM)}
            </OmniAvatar>
          </>
        </Tooltip>
      )}
      <ListItemText
        primary={
          <Typography
            variant="h6"
            sx={{
              display: "flex",
              flexDirection: "column",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.info.contrastText,
              marginTop: 0,
            }}
          >
            {getUserName(userODM)}
          </Typography>
        }
        secondary={
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              flexDirection: "row",
              marginLeft: theme.spacing(1),
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              marginTop: "-6px",
              color: theme.palette.info.contrastText,
              minimumHeight: 20,
            }}
          >
            {getUserDescription(userODM)}
          </Typography>
        }
      />
      {onNavigateHandler && (
        <OmniEditButton
          title={"Manage"}
          sx={{
            marginTop: "1px",
            marginRight: "1px",
          }}
          size="large"
          onClick={e => {
            e.stopPropagation();
            onNavigateHandler(userODM);
          }}
          icon={<OpenInNewIcon />}
        />
      )}
    </ListItem>
  );
};

export default OmniUserListItem;
